import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Homepage from './components/Homepage';
import About from './components/About';
import Nav from './components/Nav';
import Designs from './components/Designs';
import Projects from './components/Projects';
import Contact from './components/Contact';
import MenuContext from './context/MenuContext.js';
import GalleryContext from './context/GalleryContext.js';
import { useState } from 'react';

function App() {
  const [galleryVisible, setGalleryVisible] = useState("artworks");
  const [menuVisible, setMenuVisible] = useState(false);

  return (
    <BrowserRouter>
      <MenuContext.Provider value={{menuVisible, setMenuVisible}}>
        <Nav />
          <main>
            <GalleryContext.Provider value={{galleryVisible, setGalleryVisible}}>
              <Routes>
                <Route path="/" element={<Homepage />} />
                <Route path="/about" element={<About />} />
                <Route path="/designs" element={<Designs />} />
                <Route path="/projects" element={<Projects />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </GalleryContext.Provider>
        </main>
      </MenuContext.Provider>
    </BrowserRouter>
  );
}

export default App;